import deBanks from '../images/de_3.png'
import nlBanks from '../images/nl_3.png'
import frBanks from '../images/fr_3.png'
import esBanks from '../images/es_3.png'
import ptBanks from '../images/pt_3.png'
import plBanks from '../images/pl_3.png'
import skBanks from '../images/sk_3.png'
import ukBanks from '../images/uk_3.png'

export type Language = 'de' | 'nl' | 'en' | 'fr' | 'es' | 'it' | 'pt' | 'sv' | 'pl' | 'sk'

interface LanguageData {
  translations: Record<string, string>
  image: string
}
const languageData: Record<Language, LanguageData> = {
  en: {
    translations: {
      instandBankTransfer: 'Instant bank transfer',
      totalDue: 'Total due',
      fullName: 'Full name',
      email: 'Email',
      countryoOfResidence: 'Country of residence',
      dateOfBirth: 'Date of Birth',
      address: 'Address',
      phoneNumber: 'Phone number',
      amountToBePaid: 'Checkout Powered by Crypto',
      exchangeRate: 'Exchange rate',
      amountPurchased: 'Purchasing',
      youArePurchasingAmount: 'You are purchasing amount',
      youWillReceive: 'You will receive',
      yourCryptocurrencyWillBeDeliveredTo: 'Your cryptocurrency will be delivered to',
      iHaveRead: 'I have read and agree to the',
      termsOfService: 'Terms of Service',
      continueToSelectYourBank: 'Continue to select your bank',
      youAcknowledgeAndConsentToPurchasing: 'You acknowledge and consent to purchasing',
      inExchangeFor: 'in exchange for',
      aConfirmationOfYourTransactionWillBeSentTo: 'A confirmation of your transaction will be sent to',
      // filled based on FR
      billingInformation: 'Billing information',
      checkoutSummary: 'Checkout summary',
      continueToSummary: 'Continue to summary',
      selectBank: 'Select a bank',
      agreeAndContinue: 'Agree and continue',
      continueToCheckout: 'Continue to checkout',
      youSpend: 'You spend',
      youReceive: 'Receive',
      paymentMethod: 'Payment method',
      receiving: 'Receiving',
      receivingAddress: 'Receiving address',
      paymentDetails: 'Payment details',
      amount: 'Amount',
      network: 'Network',
      estTime: 'Estimated time',
      emailReceipt: 'Email receipt',
      instantBankTransfer: 'Instant bank transfer'
    },
    image: ukBanks
  },
  de: {
    translations: {
      instandBankTransfer: 'Sofortige Banküberweisung',
      totalDue: 'Gesamtbetrag fällig',
      fullName: 'Vollständiger Name',
      email: 'E-Mail',
      countryoOfResidence: 'Wohnsitzland',
      dateOfBirth: 'Geburtsdatum',
      address: 'Adresse',
      phoneNumber: 'Telefonnummer',
      amountToBePaid: 'Zu zahlender Betrag',
      exchangeRate: 'Wechselkurs',
      amountPurchased: 'Gekaufte Menge',
      youArePurchasingAmount: 'Sie kaufen Menge',
      youWillReceive: 'Sie erhalten',
      yourCryptocurrencyWillBeDeliveredTo: 'Ihre Kryptowährung wird geliefert an',
      iHaveRead: 'Ich habe gelesen und stimme den',
      termsOfService: 'Nutzungsbedingungen',
      continueToSelectYourBank: 'Weiter zur Bankauswahl',
      youAcknowledgeAndConsentToPurchasing: 'Sie bestätigen und stimmen dem Kauf von',
      inExchangeFor: 'im Austausch für',
      aConfirmationOfYourTransactionWillBeSentTo: 'Eine Bestätigung Ihrer Transaktion wird gesendet an',
      billingInformation: 'Rechnungsinformationen',
      checkoutSummary: 'Checkout-Zusammenfassung',
      continueToSummary: 'Weiter zur Zusammenfassung',
      selectBank: 'Bank auswählen',
      continueToCheckout: 'Weiter zur Kasse',
      youSpend: 'Sie geben aus',
      youReceive: 'Sie erhalten',
      paymentMethod: 'Zahlungsmethode',
      receiving: 'Empfang',
      receivingAddress: 'Empfangsadresse',
      paymentDetails: 'Zahlungsdetails',
      amount: 'Betrag',
      network: 'Netzwerk',
      estTime: 'Geschätzte Zeit',
      emailReceipt: 'E-Mail-Beleg',
      instantBankTransfer: 'Sofortige Banküberweisung',
      agreeAndContinue: 'Zustimmen und fortfahren'
    },
    image: deBanks
  },
  nl: {
    translations: {
      instandBankTransfer: 'Directe bankoverschrijving',
      totalDue: 'Totaal verschuldigd',
      fullName: 'Volledige naam',
      email: 'E-mail',
      countryoOfResidence: 'Land van verblijf',
      dateOfBirth: 'Geboortedatum',
      address: 'Adres',
      phoneNumber: 'Telefoonnummer',
      amountToBePaid: 'Te betalen bedrag',
      exchangeRate: 'Wisselkoers',
      amountPurchased: 'Aankoopbedrag',
      youArePurchasingAmount: 'U koopt bedrag',
      youWillReceive: 'U ontvangt',
      yourCryptocurrencyWillBeDeliveredTo: 'Uw cryptocurrency wordt geleverd aan',
      iHaveRead: 'Ik heb gelezen en ga akkoord met de',
      termsOfService: 'Servicevoorwaarden',
      continueToSelectYourBank: 'Ga verder om uw bank te selecteren',
      youAcknowledgeAndConsentToPurchasing: 'U erkent en stemt in met de aankoop van',
      inExchangeFor: 'in ruil voor',
      aConfirmationOfYourTransactionWillBeSentTo: 'Een bevestiging van uw transactie wordt verzonden naar',
      billingInformation: 'Factuurinformatie',
      checkoutSummary: 'Betaaloverzicht',
      continueToSummary: 'Doorgaan naar overzicht',
      selectBank: 'Selecteer een bank',
      continueToCheckout: 'Doorgaan naar afrekenen',
      youSpend: 'U besteedt',
      youReceive: 'U ontvangt',
      paymentMethod: 'Betaalmethode',
      receiving: 'Ontvangst',
      receivingAddress: 'Ontvangstadres',
      paymentDetails: 'Betalingsgegevens',
      amount: 'Bedrag',
      network: 'Netwerk',
      estTime: 'Geschatte tijd',
      emailReceipt: 'E-mailbon',
      instantBankTransfer: 'Directe bankoverschrijving',
      agreeAndContinue: 'Akkoord en doorgaan'
    },
    image: nlBanks
  },
  fr: {
    translations: {
      instandBankTransfer: 'Virement bancaire instantané',
      totalDue: 'Total dû',
      fullName: 'Nom complet',
      email: 'E-mail',
      countryoOfResidence: 'Pays de résidence',
      dateOfBirth: 'Date de naissance',
      address: 'Adresse',
      phoneNumber: 'Numéro de téléphone',
      amountToBePaid: 'Montant à payer',
      exchangeRate: 'Taux de change',
      amountPurchased: 'Achat',
      youArePurchasingAmount: 'Vous achetez le montant',
      youWillReceive: 'Vous recevrez',
      yourCryptocurrencyWillBeDeliveredTo: 'Votre cryptomonnaie sera livrée à',
      iHaveRead: "J'ai lu et j'accepte les",
      termsOfService: "Conditions d'utilisation",
      continueToSelectYourBank: 'Continuer pour sélectionner votre banque',
      youAcknowledgeAndConsentToPurchasing: "Vous reconnaissez et consentez à l'achat de",
      inExchangeFor: 'en échange de',
      aConfirmationOfYourTransactionWillBeSentTo: 'Une confirmation de votre transaction sera envoyée à',
      billingInformation: 'Informations de facturation',
      checkoutSummary: 'Résumé de la commande',
      continueToSummary: 'Continuer vers le résumé',
      selectBank: 'Sélectionner une banque',
      continueToCheckout: 'Continuer vers le paiement',
      youSpend: 'Vous Dépensez',
      youReceive: 'Vous Recevez',
      paymentMethod: 'Méthode de paiement',
      receiving: 'Réception',
      receivingAddress: 'Adresse de réception',
      paymentDetails: 'Détails de paiement',
      amount: 'Montant',
      network: 'Réseau',
      estTime: 'Temps estimé',
      emailReceipt: 'Reçu par e-mail',
      instantBankTransfer: 'Virement bancaire instantané',
      agreeAndContinue: 'Accepter et continuer'
    },
    image: frBanks
  },
  es: {
    translations: {
      instandBankTransfer: 'Transferencia bancaria instantánea',
      totalDue: 'Total adeudado',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      countryoOfResidence: 'País de residencia',
      dateOfBirth: 'Fecha de nacimiento',
      address: 'Dirección',
      phoneNumber: 'Número de teléfono',
      amountToBePaid: 'Monto a pagar',
      exchangeRate: 'Tipo de cambio',
      amountPurchased: 'Comprando',
      youArePurchasingAmount: 'Estás comprando la cantidad',
      youWillReceive: 'Recibirás',
      yourCryptocurrencyWillBeDeliveredTo: 'Tu criptomoneda será entregada a',
      iHaveRead: 'He leído y acepto los',
      termsOfService: 'Términos del servicio',
      continueToSelectYourBank: 'Continuar para seleccionar su banco',
      youAcknowledgeAndConsentToPurchasing: 'Usted reconoce y consiente la compra de',
      inExchangeFor: 'a cambio de',
      aConfirmationOfYourTransactionWillBeSentTo: 'Se enviará una confirmación de su transacción a',
      billingInformation: 'Información de facturación',
      checkoutSummary: 'Resumen del pago',
      continueToSummary: 'Continuar al resumen',
      selectBank: 'Seleccionar un banco',
      continueToCheckout: 'Continuar al pago',
      youSpend: 'Usted gasta',
      youReceive: 'Usted recibe',
      paymentMethod: 'Método de pago',
      receiving: 'Recepción',
      receivingAddress: 'Dirección de recepción',
      paymentDetails: 'Detalles de pago',
      amount: 'Monto',
      network: 'Red',
      estTime: 'Tiempo estimado',
      emailReceipt: 'Recibo por correo electrónico',
      instantBankTransfer: 'Transferencia bancaria instantánea',
      agreeAndContinue: 'Aceptar y continuar'
    },
    image: esBanks
  },
  it: {
    translations: {
      instandBankTransfer: 'Bonifico bancario istantaneo',
      totalDue: 'Totale dovuto',
      fullName: 'Nome completo',
      email: 'Email',
      countryoOfResidence: 'Paese di residenza',
      dateOfBirth: 'Data di nascita',
      address: 'Indirizzo',
      phoneNumber: 'Numero di telefono',
      amountToBePaid: 'Importo da pagare',
      exchangeRate: 'Tasso di scambio',
      amountPurchased: 'Acquisto',
      youArePurchasingAmount: 'Stai acquistando la quantità',
      youWillReceive: 'Riceverai',
      yourCryptocurrencyWillBeDeliveredTo: 'La tua criptovaluta verrà consegnata a',
      iHaveRead: 'Ho letto e accetto i',
      termsOfService: 'Termini di servizio',
      continueToSelectYourBank: 'Continua per selezionare la tua banca',
      youAcknowledgeAndConsentToPurchasing: "Riconosci e acconsenti all'acquisto di",
      inExchangeFor: 'in cambio di',
      aConfirmationOfYourTransactionWillBeSentTo: 'Una conferma della tua transazione sarà inviata a',
      billingInformation: 'Informazioni di fatturazione',
      checkoutSummary: 'Riepilogo del pagamento',
      continueToSummary: 'Continua al riepilogo',
      selectBank: 'Seleziona una banca',
      continueToCheckout: 'Continua al pagamento',
      youSpend: 'Spendi',
      youReceive: 'Ricevi',
      paymentMethod: 'Metodo di pagamento',
      receiving: 'Ricezione',
      receivingAddress: 'Indirizzo di ricezione',
      paymentDetails: 'Dettagli di pagamento',
      amount: 'Importo',
      network: 'Rete',
      estTime: 'Tempo stimato',
      emailReceipt: 'Ricevuta via e-mail',
      instantBankTransfer: 'Bonifico bancario istantaneo',
      agreeAndContinue: 'Accetta e continua'
    },
    image: esBanks
  },
  pt: {
    translations: {
      instandBankTransfer: 'Transferência bancária instantânea',
      totalDue: 'Total devido',
      fullName: 'Nome completo',
      email: 'E-mail',
      countryoOfResidence: 'País de residência',
      dateOfBirth: 'Data de nascimento',
      address: 'Endereço',
      phoneNumber: 'Número de telefone',
      amountToBePaid: 'Valor a pagar',
      exchangeRate: 'Taxa de câmbio',
      amountPurchased: 'Compra',
      youArePurchasingAmount: 'Você está comprando a quantidade',
      youWillReceive: 'Você receberá',
      yourCryptocurrencyWillBeDeliveredTo: 'Sua criptomoeda será entregue a',
      iHaveRead: 'Eu li e concordo com os',
      termsOfService: 'Termos de Serviço',
      continueToSelectYourBank: 'Continuar para selecionar seu banco',
      youAcknowledgeAndConsentToPurchasing: 'Você reconhece e concorda em comprar',
      inExchangeFor: 'em troca de',
      aConfirmationOfYourTransactionWillBeSentTo: 'Uma confirmação da sua transação será enviada para',
      billingInformation: 'Informações de faturamento',
      checkoutSummary: 'Resumo do pagamento',
      continueToSummary: 'Continuar para o resumo',
      selectBank: 'Selecionar um banco',
      continueToCheckout: 'Continuar para o pagamento',
      youSpend: 'Você gasta',
      youReceive: 'Você recebe',
      paymentMethod: 'Método de pagamento',
      receiving: 'Recebimento',
      receivingAddress: 'Endereço de recebimento',
      paymentDetails: 'Detalhes do pagamento',
      amount: 'Valor',
      network: 'Rede',
      estTime: 'Tempo estimado',
      emailReceipt: 'Recibo por e-mail',
      instantBankTransfer: 'Transferência bancária instantânea',
      agreeAndContinue: 'Concordar e continuar'
    },
    image: ptBanks
  },
  sv: {
    translations: {
      instandBankTransfer: 'Omedelbar banköverföring',
      totalDue: 'Totalt förfaller',
      fullName: 'Fullständigt namn',
      email: 'E-post',
      countryoOfResidence: 'Bostadsland',
      dateOfBirth: 'Födelsedatum',
      address: 'Adress',
      phoneNumber: 'Telefonnummer',
      amountToBePaid: 'Belopp att betala',
      exchangeRate: 'Växelkurs',
      amountPurchased: 'Köp',
      youArePurchasingAmount: 'Du köper belopp',
      youWillReceive: 'Du kommer att ta emot',
      yourCryptocurrencyWillBeDeliveredTo: 'Din kryptovaluta kommer att levereras till',
      iHaveRead: 'Jag har läst och godkänner',
      termsOfService: 'Användarvillkor',
      continueToSelectYourBank: 'Fortsätt för att välja din bank',
      youAcknowledgeAndConsentToPurchasing: 'Du bekräftar och samtycker till att köpa',
      inExchangeFor: 'i utbyte mot',
      aConfirmationOfYourTransactionWillBeSentTo: 'En bekräftelse på din transaktion kommer att skickas till',
      billingInformation: 'Faktureringsinformation',
      checkoutSummary: 'Betalningsöversikt',
      continueToSummary: 'Fortsätt till översikt',
      selectBank: 'Välj bank',
      continueToCheckout: 'Fortsätt till betalning',
      youSpend: 'Du spenderar',
      youReceive: 'Du får',
      paymentMethod: 'Betalningsmetod',
      receiving: 'Mottagning',
      receivingAddress: 'Mottagningsadress',
      paymentDetails: 'Betalningsdetaljer',
      amount: 'Belopp',
      network: 'Nätverk',
      estTime: 'Uppskattad tid',
      emailReceipt: 'Kvitto via e-post',
      instantBankTransfer: 'Omedelbar banköverföring',
      agreeAndContinue: 'Godkänn och fortsätt'
    },
    image: esBanks
  },
  pl: {
    translations: {
      instandBankTransfer: 'Natychmiastowy przelew bankowy',
      totalDue: 'Łączna należność',
      fullName: 'Pełne imię i nazwisko',
      email: 'E-mail',
      countryoOfResidence: 'Kraj zamieszkania',
      dateOfBirth: 'Data urodzenia',
      address: 'Adres',
      phoneNumber: 'Numer telefonu',
      amountToBePaid: 'Kwota do zapłaty',
      exchangeRate: 'Kurs wymiany',
      amountPurchased: 'Zakup',
      youArePurchasingAmount: 'Kupujesz kwotę',
      youWillReceive: 'Otrzymasz',
      yourCryptocurrencyWillBeDeliveredTo: 'Twoja kryptowaluta zostanie dostarczona do',
      iHaveRead: 'Przeczytałem i zgadzam się z',
      termsOfService: 'Warunkami korzystania z usługi',
      continueToSelectYourBank: 'Kontynuuj, aby wybrać swój bank',
      youAcknowledgeAndConsentToPurchasing: 'Potwierdzasz i zgadzasz się na zakup',
      inExchangeFor: 'w zamian za',
      aConfirmationOfYourTransactionWillBeSentTo: 'Potwierdzenie twojej transakcji zostanie wysłane na',
      billingInformation: 'Dane do faktury',
      checkoutSummary: 'Podsumowanie płatności',
      continueToSummary: 'Przejdź do podsumowania',
      selectBank: 'Wybierz bank',
      continueToCheckout: 'Przejdź do płatności',
      youSpend: 'Wydajesz',
      youReceive: 'Otrzymujesz',
      paymentMethod: 'Metoda płatności',
      receiving: 'Odbiór',
      receivingAddress: 'Adres odbioru',
      paymentDetails: 'Szczegóły płatności',
      amount: 'Kwota',
      network: 'Sieć',
      estTime: 'Szacowany czas',
      emailReceipt: 'Potwierdzenie e-mailem',
      instantBankTransfer: 'Natychmiastowy przelew bankowy',
      agreeAndContinue: 'Zgadzam się i kontynuuję'
    },
    image: plBanks
  },
  sk: {
    translations: {
      instandBankTransfer: 'Okamžitý bankový prevod',
      totalDue: 'Celková splatná suma',
      fullName: 'Celé meno',
      email: 'E-mail',
      countryoOfResidence: 'Krajina bydliska',
      dateOfBirth: 'Dátum narodenia',
      address: 'Adresa',
      phoneNumber: 'Telefónne číslo',
      amountToBePaid: 'Suma na zaplatenie',
      exchangeRate: 'Výmenný kurz',
      amountPurchased: 'Nákup',
      youArePurchasingAmount: 'Kupujete množstvo',
      youWillReceive: 'Obdržíte',
      yourCryptocurrencyWillBeDeliveredTo: 'Vaša kryptomena bude doručená na',
      iHaveRead: 'Prečítal som si a súhlasím s',
      termsOfService: 'Podmienkami používania',
      continueToSelectYourBank: 'Pokračovať na výber vašej banky',
      youAcknowledgeAndConsentToPurchasing: 'Potvrdzujete a súhlasíte s nákupom',
      inExchangeFor: 'výmenou za',
      aConfirmationOfYourTransactionWillBeSentTo: 'Potvrdenie o vašej transakcii bude zaslané na',
      billingInformation: 'Fakturačné údaje',
      checkoutSummary: 'Zhrnutie platby',
      continueToSummary: 'Pokračovať na zhrnutie',
      selectBank: 'Vybrať banku',
      continueToCheckout: 'Pokračovať k platbe',
      youSpend: 'Miniete',
      youReceive: 'Dostanete',
      paymentMethod: 'Spôsob platby',
      receiving: 'Prijímanie',
      receivingAddress: 'Adresa prijatia',
      paymentDetails: 'Podrobnosti platby',
      amount: 'Suma',
      network: 'Sieť',
      estTime: 'Odhadovaný čas',
      emailReceipt: 'Potvrdenie e-mailom',
      instantBankTransfer: 'Okamžitý bankový prevod',
      agreeAndContinue: 'Súhlasím a pokračujem'
    },
    image: skBanks
  }
}

let currentLanguage: Language = 'en'

export const setLanguage = (lang: Language): void => {
  currentLanguage = lang
}

export const t = (key: string): string => {
  return languageData[currentLanguage].translations[key] || key
}

export const tBank = (): string => {
  return languageData[currentLanguage].image
}
